// extracted by mini-css-extract-plugin
export default {"wrap":"XG-z","fullWidth":"YG-z","hideOnDesktop":"ZG-z","content":"_G-z","hasOpenedNav":"aH-z","crumbsList":"bH-z","dropdownsWrap":"cH-z"};